// extracted by mini-css-extract-plugin
module.exports = {"card":"_3tsPFOEd","image":"VrEUES9m","cardTitle":"_3T0hRuhW","details":"_3q3SgUi5","description":"_20y2dXmE","morePathways":"_3-KHB-2j"};